<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">รายงานสรุปคลังสินค้า</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="12" md="12" lg="6" xl="6" cols="12">
          <div class="ma-5">
            <v-card elevation="4" class="pa-3 card_relative" style="height:100%;">
              <div class="tag_header_profile d-flex">
                <div class="grad-dark-brown-arin-bg pa-3 rounded-pill"
                  style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                  <div class="logo_timeline mx-auto my-auto">
                    <img src="@/assets/arin_assets/box.png">
                  </div>
                </div>
                <v-card elevation="3" class="card_title ml-n5">
                  <div class="arin-text-color d-flex align-center py-1 pl-8 pr-5">
                    <div>รายการสินค้าใกล้หมดคลัง</div>
                    <h2 class="mx-2">{{ count_all }}</h2>
                    <div class="text_unit" style="color:#616A6B;">รายการ</div>
                  </div>
                </v-card>
              </div>
              <div class="mt-4">
                <v-data-table :headers="headers" :items="data_list" :hide-default-footer="true" mobile-breakpoint="0">
                  <template v-slot:item="dataDetail">
                    <tr>
                      <td>
                        <div>{{ dataDetail.item.product_code }}</div>
                      </td>
                      <td>
                        <div>{{ dataDetail.item.product_name }}</div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-pagination class="justify-end" v-model="page" :length="page_all" :total-visible="7"
                  color="#D6BFAF"></v-pagination>
              </div>
            </v-card>
          </div>
        </v-col>

        <v-col sm="12" md="12" lg="6" xl="6" cols="12">
          <div class="ma-5">
            <v-card elevation="4" class="pa-3 card_relative" style="height:100%;">
              <div class="tag_header_profile d-flex">
                <div class="grad-dark-brown-arin-bg pa-3 rounded-pill"
                  style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                  <div class="logo_timeline mx-auto my-auto">
                    <img src="@/assets/arin_assets/bank_white.png">
                  </div>
                </div>
                <v-card elevation="3" class="card_title ml-n5">
                  <div class="arin-text-color d-flex align-center py-1 pl-8 pr-5">
                    <div>มูลค่ายอดสินค้าที่ออกจากคลัง</div>
                    <h2 class="mx-2">{{ formatPrice(count_all3) }}</h2>
                    <div class="text_unit" style="color:#616A6B;">บาท</div>
                  </div>
                </v-card>
              </div>
              <div class="mt-5">
                <div class="ma-2 d-flex justify-end">
                  <div>
                    <!-- <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field color="#86bc3a" v-model="date" label="วันที่ (วัน/เดือน/ปี)"
                          prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined
                          dense></v-text-field>
                      </template>
                      <v-date-picker color="#86bc3a" @change="diffDateTH(dateEN)" v-model="dateEN"> </v-date-picker>
                    </v-menu> -->
                  </div>
                </div>
                <div class="d-flex justify-center align-center" style="height: 45vh !important">
                  <canvas id="myChart"></canvas>
                </div>
              </div>
            </v-card>
          </div>
        </v-col>
      </v-row>

      <v-row class="">
        <v-col cols="12">
          <div class="ma-5">
            <v-card elevation="4" class="pa-3 card_relative">
              <div class="tag_header_profile d-flex">
                <div class="grad-dark-brown-arin-bg pa-3 rounded-pill"
                  style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                  <div class="logo_timeline mx-auto my-auto">
                    <img src="@/assets/arin_assets/box.png">
                  </div>
                </div>
                <v-card elevation="3" class="card_title ml-n5">
                  <div class="arin-text-color d-flex align-center py-1 pl-8 pr-5">
                    <div>รายการสินค้าคงเหลือ</div>
                    <h2 class="mx-2">{{ count_all2 }}</h2>
                    <div class="text_unit" style="color:#616A6B;">รายการ</div>
                  </div>
                </v-card>
              </div>
              <div class="mt-4">
                <v-data-table :headers="headers2" :items="data_list2" :hide-default-footer="true" mobile-breakpoint="0">
                  <template v-slot:item="dataDetail">
                    <tr>
                      <td>
                        <div>{{ dataDetail.item.product_code }}</div>
                      </td>
                      <td>
                        <div>{{ dataDetail.item.product_name }}</div>
                      </td>
                      <td>
                        <div>{{ dataDetail.item.name_sci }}</div>
                      </td>
                      <td class="text-center">
                        <div>{{ dataDetail.item.in_stock }}</div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-pagination class="justify-end" v-model="page2" :length="page_all2" :total-visible="7"
                  color="#D6BFAF"></v-pagination>
              </div>
            </v-card>
          </div>
        </v-col>
      </v-row>

    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import { minDate } from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/numberformats";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Detail_employee",
  data() {
    return {
      loading_page: false,
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'คลังสินค้า',
          disabled: false,
        },
        {
          text: 'รายงานสรุปคลังสินค้า',
          disabled: false,
          href: '#',
        },
      ],
      headers: [
        {
          text: 'รหัสสินค้า',
          value: '',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ชื่อสินค้า',
          value: '',
          fixed: true,
          width: '150px',
        },
      ],
      count_all: 0,
      count_all2: 0,
      count_all3: 0,
      data_list: [
        // {
        //   id: 1,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        // },
        // {
        //   id: 2,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        // },
        // {
        //   id: 3,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        // },
        // {
        //   id: 4,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        // },
        // {
        //   id: 5,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        // },
        // {
        //   id: 6,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        // },
        // {
        //   id: 7,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        // },
        // {
        //   id: 8,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        // },
        // {
        //   id: 9,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        // },
        // {
        //   id: 10,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        // },
      ],
      headers2: [
        {
          text: 'รหัสสินค้า',
          value: '',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ชื่อสินค้า',
          value: '',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ชื่อทางการแพทย์',
          value: '',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: '',
          fixed: true,
          width: '150px',
          align: 'center'
        },
      ],
      data_list2: [
        // {
        //   id: 1,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        //   doctor_name: 'Mupirocin',
        //   amount: '50',
        // },
        // {
        //   id: 2,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        //   doctor_name: 'Mupirocin',
        //   amount: '50',
        // },
        // {
        //   id: 3,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        //   doctor_name: 'Mupirocin',
        //   amount: '50',
        // },
        // {
        //   id: 4,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        //   doctor_name: 'Mupirocin',
        //   amount: '50',
        // },
        // {
        //   id: 5,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        //   doctor_name: 'Mupirocin',
        //   amount: '50',
        // },
        // {
        //   id: 6,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        //   doctor_name: 'Mupirocin',
        //   amount: '50',
        // },
        // {
        //   id: 7,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        //   doctor_name: 'Mupirocin',
        //   amount: '50',
        // },
        // {
        //   id: 8,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        //   doctor_name: 'Mupirocin',
        //   amount: '50',
        // },
        // {
        //   id: 9,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        //   doctor_name: 'Mupirocin',
        //   amount: '50',
        // },
        // {
        //   id: 10,
        //   number: 'ANB0015',
        //   name: 'inj.GLUCOSE 20 CC',
        //   doctor_name: 'Mupirocin',
        //   amount: '50',
        // },
      ],
      menu_date: false,
      date: '',
      dateEN: '',
      start_date: this.min_date(),
      page: 1,
      size: 10,
      page_all: 1,
      page2: 1,
      size2: 10,
      page_all2: 1,
    }
  },
  methods: {
    formatPrice(evt) {
      return formatPrice(evt)
    },
    getdata() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get(`/pos/storage/dashboard/product/less?page=${this.page}&size=${this.size}`, config).then(async (res) => {
        if (res.data.successful === true) {
          // this.loading_page = false;
          this.data_list = await res.data.data;
          this.page = parseInt(res.data.current_page ? res.data.current_page : 1);
          this.page_all = res.data.count_page ? res.data.count_page : 1;
          // this.loading_table = true;
          this.count_all = await res.data.count_all;
        }
      })
    },
    getdata2() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get(`/pos/storage/dashboard/product/remain?page=${this.page2}&size=${this.size2}`, config).then(async (res) => {
        if (res.data.successful === true) {
          // this.loading_page = false;
          this.data_list2 = await res.data.data;
          this.page2 = parseInt(res.data.current_page ? res.data.current_page : 1);
          this.page_all2 = res.data.count_page ? res.data.count_page : 1;
          // this.loading_table = true;
          this.count_all2 = await res.data.count_all;
        }
      })
    },

    getData3() {

    },

    async chart() {
      let data = {
        labels: [],
        datasets: [
          {
            label: 'ต้นทุน',
            data: [],
            borderColor: '#939590',
            backgroundColor: '#939590',
            fill: false,

          },
        ]
      }
      let config = {
        type: 'line',
        data: data,
        options: {
          responsive: true,
          maintainAspectRatio: true,
          height: 1500  //set the height to 500 pixels
        }
      }

      if (this.date == '') {
        var currentDate = new Date();
        var day = currentDate.getDate();
        var month = currentDate.getMonth() + 1; // Month is zero-based, so add 1
        var year = currentDate.getFullYear() + 543; // Add 543 to convert to Thai Buddhist calendar
        this.date = `${day}/${month}/${year}`;
      }
      const configa = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      await HTTP_ARIN.get(`/pos/storage/dashboard?date=${this.date}`, configa).then(async (res) => {
        if (res.data.successful === true) {
          // this.loading_page = false;
          this.data_list3 = await res.data.product_dump;
          data.labels = []
          data.datasets[0].data = [0]
          await this.data_list3.map(v => {
            data.labels = [
              ...data.labels,
              v.name
            ]
            data.datasets[0].data = [
              ...data.datasets[0].data,
              v.total_dump
            ]
          })
          // this.loading_table = true;
          this.count_all3 = await res.data.sum;
        }
      })

      const ctx = await document.getElementById('myChart').getContext('2d');
      if (this.myChartCost) {
        // If the chart already exists, destroy it before creating a new one
        this.myChartCost.destroy();
      }
      this.myChartCost = await new Chart(ctx, config)
    },
    min_date: function () {
      return minDate()
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0]) + 543
      const final_date = day + '/' + month + '/' + year
      return this.date = final_date
    },
    diffDateEN() {
      const diff = this.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year + '-' + month + '-' + day
    },
  },
  mounted() {
    this.chart()
    this.getdata()
    this.getdata2()
    this.getData3()
  },
  watch: {
    page() {
      this.getdata()
    },
    page2() {
      this.getdata2()
    },
    async date() {
      await this.chart()
    }
  }
}
</script>

<style scoped>
.card_relative {
  position: relative;
  border-radius: 15px;
}

.profile_detail {
  display: grid;
  grid-template-columns: 30% 70%;
}

.header_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.logo_timeline {
  width: 25px;
  height: 25px;
}

.logo_timeline>img {
  max-width: 25px;
}

.tag_header_profile {
  position: absolute;
  top: -30px;
  left: -15px;
}

.arin-text-color {
  color: #84611F;
  font-weight: bold;
  font-size: 16px;
}

.arin-text-color-two {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.card_title {
  margin-top: 1px;
  margin-bottom: 1px;
  border-radius: 10px;
  border: 1px solid #D6BFAF;
}

.preview {
  border-radius: 10px;
}

.employee_box {
  border-radius: 10px;
  border: 1px solid #D6BFAF;
  width: auto;
}

.sub_title {
  font-size: 16px;
}

.image_title {
  font-weight: 500;
  font-size: 16px;
}

.picture_details {
  display: grid;
  grid-template-columns: 40% 60%;
}

.mobile_btn {
  width: 40%;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_four_ck {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}

.text_title {
  color: #909090;
  font-weight: bold;
  font-size: 16px;
}

.text_detail {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.text_unit {
  font-size: 20px;
}

.v-application {
  padding: 13px !important;
}

.logo_timeline {
  padding: 0px;
}
</style>
